var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cart_svg__Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cart_svg__cls-1{fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cart_svg__cls-1",
    d: "M8 26.25C8 25.01 9.01 24 10.25 24s2.25 1.01 2.25 2.25-1.01 2.25-2.25 2.25S8 27.49 8 26.25ZM19.75 26.25c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25S23.24 28.5 22 28.5s-2.25-1.01-2.25-2.25ZM0 3c0-.55.45-1 1-1h3.73c.47 0 .88.33.98.8l1.02 4.87H26c.3 0 .58.13.77.37.19.23.27.54.21.83l-1.89 9.52c-.16.76-.59 1.44-1.2 1.91s-1.37.72-2.15.71H10.27c-.77.01-1.53-.24-2.15-.71a3.204 3.204 0 0 1-1.2-1.91L4.95 8.93s-.01-.06-.02-.09L3.92 4.01H1c-.55 0-1-.45-1-1Zm7.14 6.67 1.73 8.31c.06.28.22.54.47.74.25.19.57.3.9.29h11.52c.33 0 .65-.1.9-.29.25-.19.41-.45.47-.73l1.65-8.31H7.14Z"
  })));
};

export default SvgCart;